import { formatDate } from '@angular/common';
import { Specification } from '../models/specification.models';
import { Service } from '../models/service.models';

export function getSpecificationLabel(specification: Specification) {
  return `${specification.name} - v${specification.version} - ${formatDate(
    specification.updatedAt,
    'MMMM d, yyyy',
    'en-US',
  )}`;
}

export function getServiceLabel(service: Service) {
  return `${service.name}`;
}
